import {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import {FilterTextfield} from '../pin_management';
import {useTranslation} from 'react-i18next';
import API from '../../../app/api';
import {useDispatch} from 'react-redux';
import {setLoading} from "../../../store/reducers/patient";
import _ from 'lodash';
import {ColumnTypes} from '../hl7/hl7_messages_comp';
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TableRow,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import config from '../../../app/config';
import NavigateBeforeSharpIcon from '@mui/icons-material/NavigateBeforeSharp';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {useWebSocket} from '../../../context/WebSocketProvider';

const AuditTypes = {
    setTrustedDevice: "Set Trusted Device",
    unlockTrustedDevice: "Unlock Trusted Device",
    lockTrustedDevice: "Lock Trusted Device",
    deleteTrustedDevice: "Delete Trusted Device",
    setPinCode: "Set Pin Code",
    deletePinCode: "Delete Pin Code",
}

const CHANNELS = ["db_audits_auditType.description_setPinCode", "db_audits_auditType.description_deletePinCode", `db_audits_auditType.description_deleteTrustedDevice`, 'db_audits_auditType.description_setTrustedDevice', 'db_audits_auditType.description_unlockTrustedDevice', 'db_audits_auditType.description_lockTrustedDevice'];

const PinAudit = props => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const abortController = new AbortController();

    const {manageSubscription, message} = useWebSocket();

    // Initial state values
    const [filterValue, setFilterValue] = useState("");
    const [auditData, setAuditData] = useState([]);

    const [filteredAuditData, setFilteredAuditData] = useState([])
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);

    useEffect(() => {
        manageSubscription(CHANNELS)
    }, []);

    const getData = async () => {
        dispatch(setLoading(true));

        try {
            const apiResponse = await API.getDocAudit(
              "type",
              "76,78,79,80,86,87",
              pageSize,
              page,
              abortController.signal
            );

            setAuditData(apiResponse);
            setFilteredAuditData(apiResponse.data);
        } catch (e) {
            props.renderErrorSnackbar("Error fetching audit logs. Please try again later.");
        } finally {
            dispatch(setLoading(false));
        }
    }
    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        getData();
    }, [page]);

    useEffect(() => {
        if (message) {
            getData();
        }
    }, [message]);

    const devicesColumns = [
        {
            name: 'dateTime',
            order: 1,
            value: 'auditDate',
            type: ColumnTypes.TEXT,
            description: 'Date Time',
            minWidth: "25%",
            maxWidth: 40,
            width: '20%',
        },
        {
            name: 'user',
            order: 1,
            value: 'auditUser',
            type: ColumnTypes.TEXT,
            description: 'User',
            minWidth: "25%",
            width: '10%',
        },
        {
            name: 'auditType',
            order: 1,
            value: 'type',
            type: ColumnTypes.TEXT,
            description: 'Audit Type',
            minWidth: "25%",
            width: '20%',
        },
        {
            name: 'details',
            order: 1,
            value: 'data',
            type: ColumnTypes.TEXT,
            description: 'Details',
            minWidth: "25%",
            width: '50%',
        },
    ]

    const handleFilterAudit = (value) => {
        const filteredData = auditData.data.filter(row => {
            return row?.auditUser.toLowerCase().includes(value.toLowerCase()) ||
                row?.data.toLowerCase().includes(value.toLowerCase()) || row.type.toLowerCase().includes(value.toLowerCase())
        });

        setFilteredAuditData(filteredData);
    }

    const handleChangePrevPage = () => setPage(prev => prev - 1)
    const handleChangeNextPage = () => setPage(prev => prev + 1)

    const isPageDisabled = () => {
        if (page >= 0 && page <= auditData?.numberOfPages) {
            if (page === auditData?.numberOfPages - 1) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    return (
        <Grid container spacing={2}>
            <FilterTextfield onChange={setFilterValue} value={filterValue} findValues={handleFilterAudit} />

            <Grid item xs={12} style={{margin:0, padding:0}}/>

            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead key={"HEAD"}>
                        {devicesColumns.map((column) => (
                            <TableCell
                                key={column.name}
                                align={column.align}
                                style={{
                                    width: column.width,
                                    border: "1px solid #80808035",
                                }}>
                                <Grid container justifyContent="space-between">
                                    <Typography variant="subtitle2" color="textSecondary">
                                        {column.description}
                                    </Typography>
                                </Grid>
                            </TableCell>
                        ))}
                    </TableHead>

                    <TableBody>
                        {!_.isEmpty(filteredAuditData) && filteredAuditData.map((row, index) => {
                            return (
                                <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.id}
                                    style={{border: '1px solid #80808035'}}
                                >
                                    {devicesColumns.map((column) => {
                                        const value = row[column.value];

                                        const getDetailsValue = () => {
                                            if (row.type.includes("Pin")) {
                                                return `User: ${value}`
                                            } else return value
                                        }

                                        return (
                                            <TableCell key={column.name + value} align={column.align}>
                                                {column.name === 'dateTime' && moment(value).format(config?.defaultDateTimeFormat)}
                                                {column.name === 'user' && value}
                                                {column.name === 'auditType' && AuditTypes[value]}
                                                {column.name === 'details' && getDetailsValue()}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell
                                colSpan={8}
                                sx={{
                                    m: _.isEmpty(auditData) && 0,
                                    p: _.isEmpty(auditData) && 0
                                }}
                            >
                                {_.isEmpty(filteredAuditData) &&
                                    <Typography
                                        variant="subtitle1"
                                        align="center"
                                        my={2}
                                    >
                                        {_.isEmpty(auditData) ? t("Loading audit data.") : t("No user audit data found.")}
                                    </Typography>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={8} >
                                Page: {page+1}
                                <IconButton size="small"
                                            disabled={page < 1}
                                            onClick={handleChangePrevPage}>
                                    <NavigateBeforeSharpIcon fontSize="small"/>
                                </IconButton>
                                <IconButton
                                    size="small"
                                    disabled={isPageDisabled()}
                                    onClick={handleChangeNextPage}
                                >
                                    <NavigateNextIcon fontSize="small" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>

            </TableContainer>


        </Grid>
    )
}

export default PinAudit;